import React, { useState, useEffect } from "react";
import VideoPlayer from "../VideoPlayer";
import styled from "@emotion/styled";
import client from "../../graphql";
import { gql } from "@apollo/client";
import { Link, useParams } from "react-router-dom";
import Spinner from "../Spinner/Spinner";
import NormalVideoPlayer from "../NormalVideoPlayer";
import "./index.css";

function MovieWatch() {
  const [state, setState] = useState({
    movie: null,
    servers: null,
    selectedServer: null,
    sources: null,
    selectedSource: 0,
    moviesList: [],
  });
  const { slug, language } = useParams();

  useEffect(() => {
    let newState = {};
    client
      .query({
        query: gql`
        query{
          servers{
            url
          }
          movies(where :{slug : "${slug}"}){
            id
            poster_path
            title
            ${
              !language
                ? `
              res_360p
              res_480p
              res_720p
              res_1080p
              `
                : ``
            }
            movie_genres{
              type
              id
            }
            ${
              language
                ? `
              dubbed_movies(where :{language :"Hindi"}){
                language
                res_360p
                res_480p
                res_720p
                res_1080p
              }
              `
                : ``
            }
          }
        }
        `,
      })
      .then((result) => {
        let sources = [];
        let movie = !language
          ? result.data.movies[0]
          : result.data.movies[0].dubbed_movies[0];
        [
          ["res_1080p", "1080p"],
          ["res_720p", "720p"],
          ["res_480p", "480p"],
          ["res_360p", "360p"],
        ].forEach((arr) => {
          if (movie[arr[0]] !== null && movie[arr[0]] !== "") {
            sources.push({
              src: result.data.servers[0].url + movie[arr[0]],
              type: "video/mp4",
              label: arr[1],
            });
          }
        });
        newState = {
          movie: result.data.movies[0],
          servers: result.data.servers,
          selectedServer: result.data.servers[0],
          sources,
        };
        return client.query({
          query: gql`
          query{
            movies(sort : "release_year:desc",limit : 10,where :{ movie_genres_in : [${result.data.movies[0].movie_genres.map(
              (genre) => `"${genre.id}"`
            )}] }){
              id
              poster_path
              title
              slug
              movie_year {
                year
              }
            }
          }
          `,
        });
      })
      .then((recommendations) => {
        newState.moviesList = recommendations.data.movies;
        newState.moviesList = newState.moviesList.filter(
          (movie) => movie.id !== newState.movie.id
        );
        setState(newState);
      })
      .catch((err) => console.log(err));
    return () => {};
  }, [slug, language]);

  const handleServerChange = (e) => {
    let sources = [];
    let movie = !language ? state.movie : state.movie.dubbed_movies[0];
    [
      ["res_1080p", "1080p"],
      ["res_720p", "720p"],
      ["res_480p", "480p"],
      ["res_360p", "360p"],
    ].forEach((arr) => {
      if (movie[arr[0]] !== null && movie[arr[0]] !== "") {
        sources.push({
          src: e.target.value + movie[arr[0]],
          type: "video/mp4",
          label: arr[1],
        });
      }
    });
    setState({
      ...state,
      sources,
    });
  };

  return (
    <>
      {state.movie !== null ? (
        <>
          <Grid>
            <PaddedContainer className={"video-wrapper"}>
              <div className={"video"}>
                {window.FRUBIL.device.isClass("Smart TV") ? (
                  <NormalVideoPlayer
                    sources={state.sources}
                    selectedSource={state.selectedSource}
                  />
                ) : (
                  <VideoPlayer
                    {...{
                      controls: true,
                      controlBar: {
                        children: [
                          "playToggle",
                          "currentTimeDisplay",
                          "durationDisplay",
                          "progressControl",
                          "volumePanel",
                          "qualitySelector",
                          "fullscreenToggle",
                        ],
                      },
                    }}
                    sources={state.sources}
                    selectedServer={state.selectedServer}
                    selectedSource={state.selectedSource}
                  />
                )}
              </div>
              <PaddedContainer className="sim-movies">
                <h3>Recommended Movies</h3>
                <ScrollerWrapper>
                  <Scroller>
                    {state.moviesList.map((vid) => {
                      return (
                        <VideoCard key={vid.poster_path}>
                          <Link
                            to={"/movies/" + vid.slug}
                            style={{ textDecoration: "none", color: "#000000" }}
                            key={vid.slug}
                          >
                            <Card>
                              <img
                                src={
                                  "//image.tmdb.org/t/p/w220_and_h330_face" +
                                  vid.poster_path
                                }
                                alt=""
                                width="100%"
                              />
                              <div className="vid-title">{vid.title}</div>
                              <div className="year">{vid.movie_year.year}</div>
                            </Card>
                          </Link>
                        </VideoCard>
                      );
                    })}
                  </Scroller>
                </ScrollerWrapper>
              </PaddedContainer>
            </PaddedContainer>
            <PaddedContainer
              style={{
                width: "auto",
                flex: 2,
                padding: "10px 20px",
                backgroundColor: "rgba(0,0,0,0.9",
                color: "white",
              }}
            >
              <div className="title">Server</div>
              <select name="server" onChange={handleServerChange}>
                {state.servers.map((server, index) => {
                  return (
                    <option
                      value={server.url}
                      selected={index === 0 ? true : false}
                      key={index}
                    >
                      Server {index + 1}
                    </option>
                  );
                })}
              </select>

              {window.FRUBIL.device.isClass("Smart TV") && (
                <>
                  <div className="title">Select Resolution</div>
                  <select
                    name="source"
                    onChange={(e) =>
                      setState({ ...state, selectedSource: e.target.value })
                    }
                  >
                    {state.sources.map((source, index) => {
                      return (
                        <option value={index} key={index}>
                          {source.label}
                        </option>
                      );
                    })}
                  </select>
                </>
              )}
              <div className="title">Currently Playing</div>
              <Poster
                src={`//image.tmdb.org/t/p/w300_and_h450_bestv2${state.movie.poster_path}`}
              ></Poster>
              <div
                className="title"
                style={{
                  maxWidth: "70%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  textAlign: "center",
                  fontSize: "97%",
                }}
              >
                {state.movie.title}
              </div>
            </PaddedContainer>
          </Grid>

          <MobileMovieRecommendations>
            <h3>Recommended Movies</h3>
            <ScrollerWrapper>
              <Scroller>
                {state.moviesList.map((vid) => {
                  return (
                    <VideoCard key={vid.poster_path}>
                      <Link
                            to={"/movies/" + vid.slug}
                            style={{ textDecoration: "none", color: "#000000" }}
                            key={vid.slug}
                          >
                            <Card>
                              <img
                                src={
                                  "//image.tmdb.org/t/p/w220_and_h330_face" +
                                  vid.poster_path
                                }
                                alt=""
                                width="100%"
                              />
                              <div className="vid-title">{vid.title}</div>
                              <div className="year">{vid.movie_year.year}</div>
                            </Card>
                          </Link>
                    </VideoCard>
                  );
                })}
              </Scroller>
            </ScrollerWrapper>
          </MobileMovieRecommendations>
        </>
      ) : (
        <div
          style={{
            flex : 0.9,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

          }}
        >
          <Spinner />
        </div>
      )}
    </>
  );
}

const Poster = styled.img`
  padding: 20px 0 10px 0;
  width: 150px;
  margin-left: auto;
  margin-right: auto;
`;

const Grid = styled.div`
  display: flex;
  max-width: 100vw;
  flex-wrap: wrap;
  padding: 20px 130px;
  @media (max-width: 876px) {
    padding: 0px 0px;
  }
  .video-wrapper {
    width: 60vw;
    height: 100%;
    @media (max-width: 1174px) {
      width: 100vw;
    }
  }

  .video {
    width: 100%;
    height: 60vh;
    @media (max-width: 876px) {
      height: 50vw;
    }
  }
`;

const PaddedContainer = styled.div`
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  .title {
    font-weight: bold;
    font-size: 105%;
    padding: 10px 0px;
  }

  select {
    padding: 5px 10px;
    margin: 10px 0px;
    font-size: 97%;
  }
  @media (max-width: 1157px) {
    padding: 0px 0px;
  }
  @media (max-width: 1174px) {
    .sim-movies {
      display: none;
    }
  }
`;

const MobileMovieRecommendations = styled.div`
  display: none;
  padding: 20px 130px;
  @media (max-width: 1174px) {
    display: block;
  }
  @media (max-width: 876px) {
    padding: 0;
    > h3 {
      padding: 0 10px;
    }
  }
`;

const ScrollerWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px auto;
  width: 100%;
  max-height: 400px;
  @media (max-width: 876px) {
    & > h3 {
      padding: 0 10px;
    }
  }
`;

const Scroller = styled.ol`
  overflow-x: scroll;
  overflow-y: hidden;
  display: flex;
  width: 100%;
  list-style-type: none;
  list-style-position: inside;
  margin: 0;
  padding: 0;
  display: flex;
`;

const VideoCard = styled.li`
  width: fit-content;
  margin: 5px 10px;
  & > div {
    width: 150px;
    & > img {
      border-radius: 20px;
    }
    @media (max-width: 768px) {
      width: 150px;
    }
  }
  @media (max-width: 768px) {
    width: 150px;
  }
`;

const Card = styled.div`
  margin: 10px 10px;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 13vw;
  .vid-title {
    font-weight: bold;
    font-size: 110%;
    padding: 5px 10px;
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
  }
  .year {
    padding: 5px 10px;
    color: rgba(0, 0, 0, 0.8);
  }
  & > img {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  @media (max-width: 768px) {
    width: 41vw;
    height: auto;
    margin: 10px 5px;
  }
`;


export default MovieWatch;
